import { inject, Injectable } from '@angular/core';

import { isEqual } from 'lodash-es';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  Observable,
} from 'rxjs';

import { Store } from '@ngrx/store';
import { RouterUrlCurrentService } from '@ts/shared/router/util-url';
import { selectQueryParams } from '@ts/shared/store/data-access-router';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  private store = inject(Store);
  private routerUrlCurrentService = inject(RouterUrlCurrentService);

  getQueryParamsDebounceTimeMs = 100;
  getQueryParamDebounceTimeMs = 100;

  private getQueryParamsRaw$(
    debounceTimeMs: number,
  ): Observable<Record<string, string>> {
    const routeConfigs = this.routerUrlCurrentService.getRouteConfigs();
    return this.store.select(selectQueryParams).pipe(
      debounceTime(debounceTimeMs),
      filter(() =>
        this.routerUrlCurrentService.isCurrentRouteSamePage(routeConfigs),
      ),
    );
  }

  getQueryParams$(): Observable<Record<string, string>> {
    return this.getQueryParamsRaw$(this.getQueryParamsDebounceTimeMs).pipe(
      distinctUntilChanged(isEqual),
    );
  }

  getQueryParam$(paramName: string): Observable<string | undefined> {
    return this.getQueryParamsRaw$(this.getQueryParamDebounceTimeMs).pipe(
      map((queryParams) => queryParams[paramName]),
      distinctUntilChanged(isEqual),
    );
  }
}
